define(function (require, exports, module) {
    'use strict';

    const config = require('config'); // JSSDK
    const settings = require('./settings'); // JSSDK

    module.exports = config(settings.params);
});
